module.exports = __webpack_public_path__ + "img/MASTERCARD_200x120.a3ea83c1.jpg";